import React from 'react';
import { Box, Typography } from '@mui/material';

const CircularProgressChart = ({
  size = 140,
  strokeWidth = 10,
  percentage = 0,
  color = '#2196f3',
  backgroundColor = '#e3f2fd',
  label = '',
  subtitle = '',
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box
        sx={{
          position: 'relative',
          width: size,
          height: size,
          margin: '0 auto',
          mb: 2,
        }}
      >
        <svg
          width={size}
          height={size}
          style={{ transform: 'rotate(-90deg)' }}
        >
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={backgroundColor}
            strokeWidth={strokeWidth}
          />
          {/* Progress circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            style={{
              transition: 'stroke-dashoffset 0.5s ease-in-out',
            }}
          />
        </svg>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,
              fontSize: `${size * 0.2}px`,
            }}
          >
            {percentage}%
          </Typography>
        </Box>
      </Box>
      {label && (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            mb: 0.5,
            color: '#ffffff',
          }}
        >
          {label}
        </Typography>
      )}
      {subtitle && (
        <Typography
          variant="caption"
          sx={{
            color: '#b0b0b0',
            fontSize: '0.75rem',
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default CircularProgressChart;

